import React from 'react';
import Icon from './icon';
import ProfileMainIcon from "../../assets/images/userImg.svg";

export default function ProfileHeaderIcon(props) {
    return (
        <div className='profilediv'>
            <Icon className='profileImage' src={props.src ? props.src : ProfileMainIcon} />
        </div>
    )
}
